import { SemanticTypography } from '../semantic-typography';

export const semanticTypography = {
    primaryFontFamily: 'Space Grotesk',
    secondaryFontFamily: 'HK Grotesk',
    weightRegular: 'Regular',
    weightMedium: 'Medium',
    // Note: Figma maps both "Semi" and "Bold" to "Bold" for DEFA.
    weightSemi: 'Bold',
    weightBold: 'Bold',
    fontSize: {
        headline: 54,
        h1: 34,
        h2: 25,
        h3: 21,
        h4: 18,
        body: 17,
        description: 15,
        descriptionSmall: 13,
    },
} satisfies SemanticTypography;
